// src/components/intake/IntakeOptionButton.js
//
// Ticket 061. The intake's own copy of the Snapshot's page-private OptionButton
// (plan D9: copy small UI pieces, leave the live pages alone). Same classes.

import React from 'react'

export default function IntakeOptionButton({ label, selected, onClick }) {
  return (
    <button
      type="button"
      className={`triage-option${selected ? ' selected' : ''}`}
      onClick={onClick}
      aria-pressed={!!selected}
    >
      <span className="triage-option-indicator round">
        {selected && (
          <svg width="10" height="10" viewBox="0 0 12 12" fill="none">
            <path d="M2 6l3 3 5-5" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        )}
      </span>
      {label}
    </button>
  )
}
